// Module
var code = "<template bindable=\"delete\">\n  <button\n    class=\"button button--ghost button--smallest button--nopadding button--icononly button--inline-input ${delete ? 'button--delete': 'button--new'}\"\n  ></button>\n</template>\n";
// Exports
export default code;